<template>
	<div class="accountant-table-tree">
		<v-tooltip top>
			<v-btn icon class="ma-0 btn-action btn-auto" @click="rowExpandedAll" slot="activator">
				<v-icon style="color: #00BFA5 !important;" size="30">
						{{ openAll ? 'remove_circle_outline' : 'add_circle_outline' }}
					<!-- <template v-if="openAll">
						remove_circle_outline
					</template>
					<template v-else>
						add_circle_outline
					</template> -->
				</v-icon>
			</v-btn>
			<span v-if="openAll">Contraer</span>
			<span v-else>Expandir</span>
		</v-tooltip>
		<v-layout row wrap class="accountant-table-tree-container">
			<v-flex xs12>
				<v-layout row class="accountant-table-tree-header">
					<v-flex
						v-for="column in columns"
						:key="column.id"
						:class="column.class"
					>
						{{ column.name }}
					</v-flex>
				</v-layout>
				<v-layout row wrap class="accountant-table-tree-body" :class="{ 'loading-body' : dialog && dialog.open }">
					<template v-if="rows.length === 0">
						<v-flex xs12 px-4 py-2 class="loading-map-container">
							<p class="loading-map-text mb-0 text-xs-center">
								No hay información para mostrar.
							</p>
						</v-flex>
					</template>
					<template v-else>
						<template v-for="(row, index) in firstParents">
							<tree-item
								:columns="columns"
								:create-plan="createPlan"
								:index="index"
								:item="row"
								:key="row.id"
								:open="row.open"
								:show-name-code="showNameCode"
								:code-reports="codeReport"
								@row-expanded="rowExpanded"
							></tree-item>
						</template>
					</template>
				</v-layout>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
	import treeItem from '@/components/accountant/tree-item';

	function created() {
		this.rowsChild = this.buildHierarchy();
		this.firstParents = this.rowsChild.filter(r => r.level === 1);
		this.codeReport = this.codeReports;
	}

	function buildHierarchy() {
		const buildTree = parentCode =>
			this.rows
				.filter(item => item.fatherAccount === parentCode)
				.map(item => ({
					...item,
					details: buildTree(item.code),
				}));
		return buildTree(null);
	}

	function expandChildren(item) {
		if (item.details) {
			item.details.forEach((child) => {
				this.$set(child, 'open', true);
				this.expandChildren(child);
			});
		}
	}

	function rowExpandedAll() {
		const opens = this.firstParents.filter(item => item.open === true);
		this.openAll = !opens.length > 0;
		this.firstParents.forEach((item) => {
			this.$set(item, 'open', this.openAll);
			this.expandChildren(item);
		});
	}

	function rowExpanded(item) {
		this.$set(item, 'open', !item.open);
	}

	function rows() {
		this.rowsChild = this.buildHierarchy();
		this.firstParents = this.rowsChild.filter(r => r.level === 1);
		this.codeReport = this.codeReports;
	}

	function data() {
		return {
			firstParents: [],
			codeReport: '',
			openAll: false,
			rowsChild: [],
		};
	}

	export default {
		name: 'accountant-table-tree',
		created,
		components: {
			treeItem,
		},
		data,
		methods: {
			rowExpanded,
			rowExpandedAll,
			buildHierarchy,
			expandChildren,
		},
		props: {
			columns: {
				default: () => [],
				type: Array,
			},
			createPlan: {
				default: false,
				type: Boolean,
			},
			dialog: {
				default: () => {},
				type: Object,
			},
			rows: {
				default: () => [],
				type: Array,
			},
			showNameCode: {
				default: false,
				type: Boolean,
			},
			codeReports: {
				default: '',
				type: String,
			},
		},
		watch: {
			rows,
		},
	};
</script>

<style lang="scss" scoped>
	.accountant-table-tree {
		&-header {
			align-items: flex-end;
			background-color: #02979B;
			color: color(white);
			font-family: font(open-regular);
			font-size: size(small);
			height: 61px;
			justify-content: center;
			padding-bottom: 12px;
			text-align: center;
		}
	}

	.loading-body {
		align-items: center;
		height: 300px;
		justify-content: center;
	}

	.loading-map {
		&-container {
			background-color: color(white);
			border: 2px solid color(background-sidebar);
			border-radius: 6px;
		}

		&-text {
			color: color(paginationText);
			font-family: font(open-semibold);
			font-size: size(small13);
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/accountant/accountant-table-tree.vue